import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=f31fb786&"
import script from "./RoleCreate.vue?vue&type=script&lang=ts&"
export * from "./RoleCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports